import fetchApi from '../backend/fetchApi';
import { operatorAdviceScrollToTop } from "../App";
import { formatStringCurrency } from "./CurrencyFormatter";
import { isCurrencyWithWholeNumbers } from './RoundHelper';


function getRemoteSuggestion(inputData) {
    const url = "https://onextwo-propick-mwkingfyqa-ew.a.run.app/suggestion";

    return fetchApi(url, {
        method: 'POST',
        body: inputData,
    }).then(response => response.json());
}

export function getProPickText(numRows, operatorStakePerRow, operatorFeePerRow, t) {

    return formatStringCurrency(Math.round(numRows * (Number(operatorStakePerRow.amount) + Number(operatorFeePerRow.amount)) * 10) / 10, operatorStakePerRow.currency, t, isCurrencyWithWholeNumbers(operatorStakePerRow.currency));
}


function getProTypesMini(operatorStakePerRow, operatorFeePerRow, t) {
    let proTypes = [];
    proTypes.push({
        price: getProPickText(36, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 2,
        numHalf: 2
    });
    proTypes.push({
        price: getProPickText(36, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 2,
        numHalf: 2
    });
    return proTypes;
}

function getProTypesFlex(operatorStakePerRow, operatorFeePerRow, t) {
    let proTypes = [];
    proTypes.push({
        price: getProPickText(32, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 0,
        numHalf: 5
    });
    proTypes.push({
        price: getProPickText(32, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 0,
        numHalf: 5
    });

    proTypes.push({
        price: getProPickText(64, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 0,
        numHalf: 6
    });
    proTypes.push({
        price: getProPickText(64, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 0,
        numHalf: 6
    });

    proTypes.push({
        price: getProPickText(96, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 1,
        numHalf: 5
    });
    proTypes.push({
        price: getProPickText(96, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 1,
        numHalf: 5
    });

    proTypes.push({
        price: getProPickText(144, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 2,
        numHalf: 4
    });
    proTypes.push({
        price: getProPickText(144, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 2,
        numHalf: 4
    });

    proTypes.push({
        price: getProPickText(216, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 3,
        numHalf: 3
    });
    proTypes.push({
        price: getProPickText(216, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 3,
        numHalf: 3
    });

    proTypes.push({
        price: getProPickText(576, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 2,
        numHalf: 6
    });
    proTypes.push({
        price: getProPickText(576, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 2,
        numHalf: 6
    });

    return proTypes;
}

function getProTypesMixMax(operatorStakePerRow, operatorFeePerRow, t) {
    let proTypes = [];

    proTypes.push({
        price: getProPickText(64, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 0,
        numHalf: 6
    });
    proTypes.push({
        price: getProPickText(64, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 0,
        numHalf: 6
    });

    proTypes.push({
        price: getProPickText(144, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 2,
        numHalf: 4
    });
    proTypes.push({
        price: getProPickText(144, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 2,
        numHalf: 4
    });

    proTypes.push({
        price: getProPickText(216, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 3,
        numHalf: 3
    });
    proTypes.push({
        price: getProPickText(216, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 3,
        numHalf: 3
    });

    proTypes.push({
        price: getProPickText(576, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 2,
        numHalf: 6
    });
    proTypes.push({
        price: getProPickText(576, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 2,
        numHalf: 6
    });

    proTypes.push({
        price: getProPickText(1296, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 4,
        numHalf: 4
    });
    proTypes.push({
        price: getProPickText(1296, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 4,
        numHalf: 4
    });

    proTypes.push({
        price: getProPickText(1944, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Easy',
        numFull: 5,
        numHalf: 3
    });
    proTypes.push({
        price: getProPickText(1944, operatorStakePerRow, operatorFeePerRow, t),
        dif: 'Hard',
        numFull: 5,
        numHalf: 3
    });

    return proTypes;
}

export function getProTypes(numGames, operatorStakePerRow, operatorFeePerRow, t) {

    if (numGames < 7)
        return getProTypesMini(operatorStakePerRow, operatorFeePerRow, t);
    if (numGames < 12)
        return getProTypesFlex(operatorStakePerRow, operatorFeePerRow, t);

    return getProTypesMixMax(operatorStakePerRow, operatorFeePerRow, t);

}

export function getSuggestion(protype, roundFixtures, setProPickRows) {
    let floor = 0.5;
    let ceiling = 1.0;

    if (protype.dif === 'Hard') {
        floor = 0;
        ceiling = 0.5;
    }

    let round = {
        Fixtures: [],
        Settings: {
            NumHalfCovers: protype.numHalf,
            NumFullCovers: protype.numFull,
            ProbabilitySpanFloor: floor,
            ProbabilitySpanCeiling: ceiling
        }
    }

    let index = 0;
    for (var fixt in roundFixtures) {
        let fixture = roundFixtures[fixt];
        let one = 0.33;
        let two = 0.33;
        let x = 0.33;

        const signs = fixture?.signs;
        if (signs?.ONE && signs?.TWO && signs?.X) {
            one = signs.ONE.rowsFraction;
            two = signs.TWO.rowsFraction;
            x = signs.X.rowsFraction;
        }
        round.Fixtures.push({ ID: index.toString(), Probabilities: { ONE: one, TWO: two, X: x } })
        index++;
    }

    let json = JSON.stringify(round);
    getRemoteSuggestion(json).then((resp) => {

        let signs = [];
        for (var rowIndex in resp.SuggestedBets) {
            let suggestedBet = resp.SuggestedBets[rowIndex];
            let index = parseInt(suggestedBet.FixtureID);
            signs[index] = suggestedBet.Signs;
        }
        setProPickRows(signs);
        operatorAdviceScrollToTop(500);
    }
    );
}



